import { PartnerType } from 'legacy/lut/classes/models/PartnerType'

import { I621Form } from '../../api/types'

export const resolvePartnerRtm = (partner?: I621Form): PartnerType | null => {
  if (partner?.RTM === PartnerType.Commercial) {
    return PartnerType.Commercial
  }

  if (partner?.RTM === PartnerType.Distributor) {
    return PartnerType.Distributor
  }

  return null
}
